import React from 'react';
import PropTypes from 'prop-types';

import { BubbleContainer, SuggestionText } from "./styles";

const SuggestionBubble = ({ suggestedText, zIndex, fillSuggestedEmail }) => (
	<BubbleContainer suggestionExists={!!suggestedText} zIndex={suggestedText ? 0 : -1}>
		<SuggestionText onClick={() => fillSuggestedEmail(suggestedText)}>
			{suggestedText ? `Did you mean ${suggestedText}?` : ''}
		</SuggestionText>
	</BubbleContainer>
);

SuggestionBubble.propTypes = {
	suggestedText: PropTypes.string,
	zIndex: PropTypes.number,
	fillSuggestedEmail: PropTypes.func,
};

SuggestionBubble.defaultProps = {
	zIndex: -1,
	suggestedText: '',
};

export default SuggestionBubble;
